// extracted by mini-css-extract-plugin
module.exports = {"resultPageItem":"Congratulation_resultPageItem__dgOXC"};